<template>
  <div class="container" v-if="!isLoading">
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :srcset="`${logo} 3x`" />
        <p class="mt-4 mb-3">
          {{ $t('SETTINGS.TEXT.CONNECT_YOUR_CALENDLY_ACCOUNT') }}
        </p>
        <HMActivatedTag
          v-if="!inProgress && calendly.calendly_auth_code"
          :label="$t('SETTINGS.LABEL.CONNECTED')"
          class="my-3"
        />
      </div>
      <div class="col-12">
        <div class="form-group">
          <div v-if="calendly.calendly_auth_code">
            <hr class="mt-0 mb-4" />
            <HMButton
              color="primary"
              @click="remove"
              :loading="inProgress"
              :disabled="inProgress"
            >
              {{ $t('SETTINGS.BUTTON.DISCONNECT_FROM_CALENDLY') }}
            </HMButton>
          </div>
          <div v-else class="mt-3">
            <HMButton
              color="primary"
              @click="connect"
              :loading="inProgress"
              :disabled="inProgress"
            >
              {{ $t('SETTINGS.BUTTON.CONNECT_CALENDLY') }}
            </HMButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'CalendlyIntegrationV2',
  components: {
    TopNav,
  },
  computed: {
    redirectUri() {
      return process.env.VUE_APP_CALENDLY_REDIRECT_URL;
    },
  },
  data() {
    return {
      logo: '/assets/images/integrations/calendly@3x.png',
      isLoading: true,
      inProgress: false,
      calendly: {},
    };
  },
  methods: {
    async update() {
      this.inProgress = true;
      try {
        this.calendly.redirect_uri = process.env.VUE_APP_CALENDLY_REDIRECT_URL;
        await this.$store.dispatch('setting/updateCalendlyV2', this.calendly);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('SETTINGS.NOTIFICATIONS.CALENDLY_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
        this.calendly.calendly_auth_code = null;
      } finally {
        this.inProgress = false;
      }
    },
    connect() {
      const responseType = 'code';
      const clientId = process.env.VUE_APP_CALENDLY_CLIENT_ID;
      const redirectURL = encodeURIComponent(this.redirectUri);
      this.inProgress = false;
      window.location = `https://auth.calendly.com/oauth/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectURL}`;
    },
    remove() {
      this.calendly.calendly_auth_code = null;
      this.update();
    },
    checkForOAuthCode() {
      const code = this.$route.query.code;
      if (!code) return;

      const query = { ...this.$route.query };
      delete query.code;
      this.$router.replace({ query });

      this.calendly.calendly_auth_code = code;
      this.update();
    },
  },
  async mounted() {
    this.calendly = await this.$store.dispatch('setting/getCalendlyV2');
    this.checkForOAuthCode();
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
